import UsuarioDadoService from "@/services/UsuarioDadoService";

export const usuarioDado = {
  namespaced: true,
  state: {
    usuarioDado: {},
  },
  actions: {
    getUsuarioDado({ commit }, payload) {
      return UsuarioDadoService.GetUsuarioDado(payload).then(
        (usuarioDado) => {
          return Promise.resolve(usuarioDado);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postUsuarioDado({ commit }, payload) {
      return UsuarioDadoService.PostUsuarioDado(payload).then(
        (usuarioDado) => {
          return Promise.resolve(usuarioDado);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putUsuarioDado({ commit }, payload) {
      return UsuarioDadoService.PutUsuarioDado(payload).then(
        (usuarioDado) => {
          return Promise.resolve(usuarioDado);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteUsuarioDado({ commit }, payload) {
      return UsuarioDadoService.DeleteUsuarioDado(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getUsuarioDadoOData({ commit }, payload) {
      return UsuarioDadoService.GetUsuarioDadoOData(payload).then(
        (usuarioDado) => {
          return Promise.resolve(usuarioDado);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default usuarioDado;
